import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BlogPost } from "../data/blogPosts";

interface BlogCardProps {
  post: BlogPost;
  index: number;
  href?: string;
}

const BlogCard: React.FC<BlogCardProps> = ({ post, index, href }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.div
      className="relative h-72 md:h-96 rounded-lg overflow-hidden"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 + 0.3 }}
      viewport={{ once: true }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img
        src={post.coverImage}
        alt={post.title}
        className={`w-full h-full object-cover transition-all duration-500 ${
          isHovered ? "scale-110" : "scale-100"
        }`}
      />
      <div
        className={`absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/30 flex flex-col justify-end p-6 transition-opacity duration-300 ${
          isHovered ? "opacity-100" : "opacity-70"
        }`}
      >
        <div className="text-sm text-gray-300 mb-2">
          {new Date(post.date).toLocaleDateString("pt-BR")}
        </div>
        <h3 className="text-xl md:text-2xl font-medium text-white mb-2 overflow-hidden">
          {post.title}
        </h3>
        <p className={`text-sm text-gray-200 mb-4 line-clamp-2 transition-all duration-300 ${
          isHovered ? "opacity-100" : "opacity-0"
        }`}>
          {post.excerpt}
        </p>
        {post.tags && post.tags.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-4">
            {post.tags.slice(0, 2).map((tag, i) => (
              <span
                key={i}
                className="bg-white/20 text-white text-xs px-2 py-1 rounded-full"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
        {href && (
          <Link
            to={href}
            className={`inline-flex items-center text-white hover:text-gray-200 transition-all duration-300 ${
              isHovered ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            Ler mais
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 ml-1"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </Link>
        )}
      </div>
    </motion.div>
  );
};

export default BlogCard;
